import HttpMixin from "../../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../../global/mixins/NotificationMixin";
import Modal from "../../../../global/components/Modal/Modal.vue";
import translate from "../../../../global/directives/translate";
import PuxButton from "../../../../global/components/PuxButton/PuxButton.vue";

// @vue/component
export default {
  name: "FoerderorgAnsprechpartnerModalMirZuweisen",
  components: {
    Modal,
    PuxButton,
  },
  directives: {
    translate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  inject: [
    "updateAnsprechpartner",
  ],
  props: {
    baseUrl: {
      type: String,
      default: undefined,
    },
    ansprechpartner: {
      type: Object,
      default: () => ({
        org: {},
      }),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    close: {
      type: Function,
      default: () => {},
    },
    selectorClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      model: {},
      options: {
        showCloseButton: true,
        required: true,
        list: [],
      },
      status: {
        loading: undefined,
      },
      errors: undefined,
      errorsClone: undefined,
    };
  },
  created() {
    this.initList();
  },
  methods: {
    initList() {
      this.options.list.push({
        id: "temp",
        type: "readonly",
        text: "_TXT_MODAL_FOERDERORG_ANSPRECHPARTNER_MIR_ZUWEISEN_ANSPRECHPARTNER_{{name}}_",
        extra: {
          name: this.ansprechpartner.org.o_name,
        }
      });
    },

    save() {
      this.status.loading = true;
      const data = {
        pk: this.ansprechpartner.pk,
      };

      this.putHttp({ url: `${ this.baseUrl }/${ this.ansprechpartner.pk }/assign_current_user_fnu/`, data }).then(
        response => {
          this.addNotification({ text: "_MSG_MODAL_FOERDERORG_ANSPRECHPARTNER_MIR_ZUWEISEN_SUCCESS_" });
          this.close({ response: response, status: true });
          this.updateAnsprechpartner();
        },
        () => {
          this.addNotification({ text: "_MSG_MODAL_FOEDERORG_ANSPRECHPARTNER_MIR_ZUWEISEN_ERROR_", type: "error" });
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
